const USDt = {
  data: {
    icon: "/imgs/icons/asset/usdt.svg",
    about:
      "Tether gives you the joint benefits of open blockchain technology and traditional currency by converting your cash into a stable digital currency equivalent.",
  },
};

export default USDt;
